try {
console.log("ready");
jQuery('[data-toggle="popover"]').popover({ container: 'body'});
res=jQuery('#internationalpopover').popover();
}catch(e){}
